import React, { useState } from "react";
import "./MembershipQuoteForm.css";
import carImg from "../assets/membershipcar.png";
import personImg from "../assets/membershipboy.png";

const MembershipQuoteForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    make: "",
    model: "",
    carClass: "",
    notes: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://driveincarspa.com/submit-membership.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData).toString(),
      });

      const text = await response.text();
      if (response.ok) {
        alert("Form submitted successfully!");
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          make: "",
          model: "",
          carClass: "",
          notes: ""
        });
      } else {
        alert("Submission failed. Please try again.");
        console.error(text);
      }
    } catch (err) {
      alert("An error occurred. Please try later.");
      console.error(err);
    }
  };

  return (
    <div className="membership-quote-container">
      <div className="membership-quote-left">
        <img src={carImg} alt="Car" className="membership-quote-car" />
        <img src={personImg} alt="Person" className="membership-quote-person" />
      </div>
      <div className="membership-quote-right">
        <h2>
          <span className="membership-quote-title">Drive-In Car Spa Membership</span>
          <br />
          <span className="membership-quote-subtitle">REQUEST A QUOTE</span>
        </h2>
        <form className="membership-quote-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name*"
            required
            value={formData.fullName}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email*"
            required
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number*"
            required
            value={formData.phone}
            onChange={handleChange}
          />
          <input
            type="text"
            name="make"
            placeholder="Car make*"
            required
            value={formData.make}
            onChange={handleChange}
          />
          <input
            type="text"
            name="model"
            placeholder="Model*"
            required
            value={formData.model}
            onChange={handleChange}
          />
          <input
            type="text"
            name="carClass"
            placeholder="Class*"
            required
            value={formData.carClass}
            onChange={handleChange}
          />
          <textarea
            name="notes"
            placeholder="Additional notes"
            rows={2}
            value={formData.notes}
            onChange={handleChange}
          />
          <button type="submit">SUBMIT ENQUIRY</button>
        </form>
      </div>
    </div>
  );
};

export default MembershipQuoteForm;
